import { literal, nullable, number, object, string } from "superstruct";

export const RewardsFreeProductSchema = object({
    type: literal("free_product"),
    discountValue: number(),
    productId: number(),
    productHandle: string(),
    productTitle: string(),
    productImage: nullable(string()),
});

//This schema is used in v3 api endpoints
export const RewardsProductSchema = object({
    id: number(),
    title: string(),
    image: nullable(string()),
    handle: string(),
});
